import { combineReducers } from 'redux'
import { components } from '@peachjar/components';
import { reducer as schoolsReducer } from 'redux/schools'
import { reducer as flyersReducer } from 'redux/flyers'
import { reducer as districtsReducer } from 'redux/districts'
import { flyerDetailReducer, flyerGridReducer } from './screens/Flyers/redux'

const { notificationsReducer } = components.Notifications;

const rootReducer = combineReducers({
  schools: schoolsReducer,
  flyers: flyersReducer,
  districts: districtsReducer,
  flyerDetails: flyerDetailReducer,
  flyerGrid: flyerGridReducer,
  notifications: notificationsReducer,
  /* list more here */
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers.js